import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "bonusomat-raffle-table__cols" }
const _hoisted_4 = { class: "bonusomat-raffle-table__image-section" }
const _hoisted_5 = { class: "bonusomat-raffle-table__image-wrap" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "bonusomat-raffle-table__table-section" }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { class: "bonusomat-raffle-table__allwyn" }
const _hoisted_10 = ["innerHTML"]

import { ref, watch, computed } from "vue";
import DsBottomSlotActionBar from "@sazka/design-system/src/bottom-slot/ds-bottom-slot-action-bar.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import DsModalDialog from "@sazka/design-system/src/modal-dialog/ds-modal-dialog.vue";
import DsSegmentedPicker from "@sazka/design-system/src/segmented-picker/ds-segmented-picker.vue";
import DsSegmentedPickerItem from "@sazka/design-system/src/segmented-picker-item/ds-segmented-picker-item.vue";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsTopSlotHeadlineSubheadline from "@sazka/design-system/src/top-slot/ds-top-subheadline.vue";
import MobileAppLink from "@sazka/mobile-apps/components/mobile-app-link.vue";
import { SvgIcons } from "@sazka/design-system/src/icon/types";
import { BonusomatAllwynDraw } from "../../models/bonusomat-draw";
import { BonusomatDefaultDrawWinTable } from "../../models/draw-win-table";
import { bonImgUrl } from "../../utils/image-src";

enum RafflePrizesPickerItem {
    LosovackaBonusomat = "Losovačka Bonusomat",
    LosovackaAllwyn = "Losovačka Allwyn",
}

export default /*@__PURE__*/_defineComponent({
  __name: 'raffle-prizes-modal',
  props: /*@__PURE__*/_mergeModels({
    defaultDrawWinTable: {},
    allwynDraw: {},
    btnSubmitText: {},
    btnRightIcon: {},
    showLoginBtn: { type: Boolean }
  }, {
    "modelValue": { type: Boolean, ...{ required: true } },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["submitDialog"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const modelValue = _useModel<boolean>(__props, "modelValue");

const props = __props;

const emit = __emit;
const allwynInformationPageUrl = appSettings["AllwynJokerPageUrl"];

const pickerActiveTab = ref(
    props.allwynDraw && !props.defaultDrawWinTable
        ? RafflePrizesPickerItem.LosovackaAllwyn
        : RafflePrizesPickerItem.LosovackaBonusomat
);

const showAllwynBtn = computed(() => pickerActiveTab.value == RafflePrizesPickerItem.LosovackaAllwyn);

const closeModal = () => {
    modelValue.value = false;
};

const submitDialog = () => {
    emit("submitDialog", null);
    closeModal();
};

const preselectAppropriateTab = () => {
    if (
        !props.defaultDrawWinTable &&
        props.allwynDraw &&
        pickerActiveTab.value == RafflePrizesPickerItem.LosovackaBonusomat
    ) {
        pickerActiveTab.value = RafflePrizesPickerItem.LosovackaAllwyn;
    } else if (pickerActiveTab.value != RafflePrizesPickerItem.LosovackaBonusomat) {
        pickerActiveTab.value = RafflePrizesPickerItem.LosovackaBonusomat;
    }
};

watch(
    () => props.defaultDrawWinTable,
    (newDefaultDrawWinTable) => {
        if (!newDefaultDrawWinTable) {
            if (props.allwynDraw) {
                pickerActiveTab.value = RafflePrizesPickerItem.LosovackaAllwyn;
            } else {
                closeModal();
            }
        }
    }
);

watch(
    () => props.allwynDraw,
    (newAllwynDraw) => {
        if (!newAllwynDraw) {
            if (props.defaultDrawWinTable) {
                pickerActiveTab.value = RafflePrizesPickerItem.LosovackaBonusomat;
            } else {
                closeModal();
            }
        }
    }
);

watch(
    modelValue,
    () => {
        preselectAppropriateTab();
    },
    {
        immediate: true,
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsModalDialog, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": [
      _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
      closeModal
    ],
    "css-class": [
            'bonusomat-raffle-table',
            pickerActiveTab.value == RafflePrizesPickerItem.LosovackaBonusomat ? 'bonusomat-raffle-table--bonusomat' : '',
        ],
    theme: "dark"
  }, {
    top: _withCtx(() => [
      (_ctx.defaultDrawWinTable && _ctx.allwynDraw)
        ? (_openBlock(), _createBlock(DsSegmentedPicker, {
            key: 0,
            class: "ft-detail-body__picker",
            theme: "dark",
            size: "lg",
            modelValue: pickerActiveTab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pickerActiveTab).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(DsSegmentedPickerItem, {
                title: RafflePrizesPickerItem.LosovackaBonusomat,
                name: RafflePrizesPickerItem.LosovackaBonusomat
              }, null, 8, ["title", "name"]),
              _createVNode(DsSegmentedPickerItem, {
                title: RafflePrizesPickerItem.LosovackaAllwyn,
                name: RafflePrizesPickerItem.LosovackaAllwyn
              }, null, 8, ["title", "name"])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (pickerActiveTab.value == RafflePrizesPickerItem.LosovackaBonusomat)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(DsTopSlotHeadlineSubheadline, {
              headline: _ctx.defaultDrawWinTable?.title,
              "display-headline-as-html": true
            }, null, 8, ["headline"]),
            _createElementVNode("p", {
              class: "bonusomat-raffle-table__description",
              innerHTML: _ctx.defaultDrawWinTable?.description
            }, null, 8, _hoisted_1)
          ], 64))
        : (pickerActiveTab.value == RafflePrizesPickerItem.LosovackaAllwyn)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(DsTopSlotHeadlineSubheadline, {
                headline: _ctx.allwynDraw?.winTable?.title,
                "display-headline-as-html": true
              }, null, 8, ["headline"]),
              _createElementVNode("p", {
                class: "bonusomat-raffle-table__description",
                innerHTML: _ctx.allwynDraw?.winTable?.description
              }, null, 8, _hoisted_2)
            ], 64))
          : _createCommentVNode("", true)
    ]),
    content: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(WebpImage, {
              src: _unref(bonImgUrl)('raffle/zombies-with-ticket', 'png'),
              alt: "Pán Zelený s Pánem Červeným stojící vedle barelu toxické tekutiny",
              "css-class": "bonusomat-raffle-table__image"
            }, null, 8, ["src"])
          ]),
          _createElementVNode("p", {
            class: "bonusomat-raffle-table__description",
            innerHTML: _ctx.defaultDrawWinTable?.mainText
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "bonusomat-raffle-table__label" }, "Co můžete vyhrát?", -1)),
          _createVNode(DsTable, { theme: "dark" }, {
            default: _withCtx(() => [
              _createVNode(DsRow, null, {
                default: _withCtx(() => [
                  _createVNode(DsCell, { type: "th" }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("Pořadí")
                    ])),
                    _: 1,
                    __: [2]
                  }),
                  _createVNode(DsCell, { type: "th" }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("Cena")
                    ])),
                    _: 1,
                    __: [3]
                  })
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultDrawWinTable?.prizes, (item, index) => {
                return (_openBlock(), _createBlock(DsRow, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(DsCell, null, {
                      default: _withCtx(() => [
                        (index === 0)
                          ? (_openBlock(), _createBlock(WebpImage, {
                              key: 0,
                              src: _unref(bonImgUrl)('raffle/medal-1st', 'svg'),
                              alt: "Zlatá medaile",
                              "css-class": "bonusomat-raffle-table__table-img--medal"
                            }, null, 8, ["src"]))
                          : (index === 1)
                            ? (_openBlock(), _createBlock(WebpImage, {
                                key: 1,
                                src: _unref(bonImgUrl)('raffle/medal-2nd', 'svg'),
                                alt: "Stříbrná medaile",
                                "css-class": "bonusomat-raffle-table__table-img--medal"
                              }, null, 8, ["src"]))
                            : (index === 2)
                              ? (_openBlock(), _createBlock(WebpImage, {
                                  key: 2,
                                  src: _unref(bonImgUrl)('raffle/medal-3rd', 'svg'),
                                  alt: "Bronzová medaile",
                                  "css-class": "bonusomat-raffle-table__table-img--medal"
                                }, null, 8, ["src"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(index + 1) + ".", 1))
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(DsCell, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])
      ], 512), [
        [_vShow, pickerActiveTab.value == RafflePrizesPickerItem.LosovackaBonusomat]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        _withDirectives(_createVNode(WebpImage, {
          "css-class": "bonusomat-raffle-table__allwyn-logo",
          src: _ctx.allwynDraw?.winTable?.imageLogo,
          alt: "Zážitek - logo",
          "loading-priority": 'high'
        }, null, 8, ["src"]), [
          [_vShow, _ctx.allwynDraw?.winTable?.imageLogo]
        ]),
        _withDirectives(_createVNode(WebpImage, {
          "css-class": "bonusomat-raffle-table__allwyn-image",
          src: _ctx.allwynDraw?.winTable?.image,
          alt: "Zážitek - obrázek",
          "loading-priority": 'high'
        }, null, 8, ["src"]), [
          [_vShow, _ctx.allwynDraw?.winTable?.image]
        ]),
        _createElementVNode("p", {
          class: "bonusomat-raffle-table__description",
          innerHTML: _ctx.allwynDraw?.winTable?.mainText
        }, null, 8, _hoisted_10)
      ], 512), [
        [_vShow, pickerActiveTab.value == RafflePrizesPickerItem.LosovackaAllwyn]
      ])
    ]),
    bottom: _withCtx(() => [
      _createVNode(DsBottomSlotActionBar, {
        "has-btn-close": false,
        "has-btn-submit": !_ctx.showLoginBtn && !showAllwynBtn.value,
        "button-submit-icon": _ctx.btnRightIcon && { iconRight: _ctx.btnRightIcon },
        theme: "dark",
        size: "sm",
        "btn-submit-text": _ctx.btnSubmitText ?? 'Rozumím',
        onSubmitDialog: submitDialog
      }, _createSlots({ _: 2 }, [
        (_ctx.showLoginBtn || showAllwynBtn.value)
          ? {
              name: "additional",
              fn: _withCtx(() => [
                (showAllwynBtn.value)
                  ? (_openBlock(), _createBlock(DsButton, {
                      key: 0,
                      href: _unref(allwynInformationPageUrl),
                      eventName: "openLinkBrowser",
                      "event-argument": _unref(allwynInformationPageUrl),
                      openInNewTab: true,
                      type: "primary",
                      "icon-right": "arrow-right",
                      theme: "dark",
                      size: "sm"
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode(" Joker výhody ")
                      ])),
                      _: 1,
                      __: [5]
                    }, 8, ["href", "event-argument"]))
                  : (_ctx.showLoginBtn)
                    ? (_openBlock(), _createBlock(MobileAppLink, {
                        key: 1,
                        href: "javascript:ng_fw.showLogin();",
                        "event-name": "goToDeepLink",
                        "event-argument": "sazkahry://home/login",
                        class: "button button--primary button--dark button--sm",
                        onLinkClicked: submitDialog
                      }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode(" Přihlásit se ")
                        ])),
                        _: 1,
                        __: [6]
                      }))
                    : _createCommentVNode("", true)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["has-btn-submit", "button-submit-icon", "btn-submit-text"])
    ]),
    _: 1
  }, 8, ["modelValue", "css-class"]))
}
}

})